import { z } from 'zod';
import { typeColorInput } from '../calendar/appointment-types.js';
/**
 * Einstellungen des Moduls Produkte (KON-110 bis KON-112): Haupt- und Unterkategorien, Einheiten und Tags. Der Mandant pflegt sie in der Einrichtung unter „Produkte“.
 */
const reorder = z.object({ ids: z.array(z.uuid('Ungültige ID')).min(1).max(500) });
// ---------------------------------------------------------------------------
// Kategorien (KON-110): genau zwei Ebenen
// ---------------------------------------------------------------------------
const categoryName = z.string().trim().min(2, 'Bezeichnung fehlt').max(80, 'Höchstens 80 Zeichen');
export const createProductCategoryInput = z.object({
    name: categoryName,
    /** Hauptkategorie, wenn es eine Unterkategorie werden soll */
    parentId: z.uuid('Ungültige Hauptkategorie').nullable().optional(),
});
export const updateProductCategoryInput = z.object({ name: categoryName }).strict();
/** Neue Reihenfolge der Hauptkategorien oder der Unterkategorien einer Hauptkategorie, jeweils vollständig */
export const reorderProductCategoriesInput = reorder.extend({ parentId: z.uuid().nullable().default(null) });
// ---------------------------------------------------------------------------
// Einheiten (KON-111)
// ---------------------------------------------------------------------------
export const createProductUnitInput = z.object({
    name: z.string().trim().min(1, 'Bezeichnung fehlt').max(40, 'Höchstens 40 Zeichen'),
    symbol: z.string().trim().min(1, 'Kürzel fehlt').max(20, 'Höchstens 20 Zeichen'),
});
export const updateProductUnitInput = createProductUnitInput
    .partial()
    .strict()
    .refine((v) => Object.values(v).some((x) => x !== undefined), 'Keine Änderung angegeben');
export const reorderProductUnitsInput = reorder;
/** Vorschläge für neue Mandanten, die Migration 0024 legt dieselben für bestehende an */
export const DEFAULT_PRODUCT_UNITS = [
    { name: 'Stück', symbol: 'Stk.' },
    { name: 'Stunde', symbol: 'Std.' },
    { name: 'Tag', symbol: 'Tag' },
    { name: 'Pauschal', symbol: 'pauschal' },
    { name: 'Meter', symbol: 'm' },
    { name: 'Quadratmeter', symbol: 'm²' },
    { name: 'Kubikmeter', symbol: 'm³' },
    { name: 'Kilogramm', symbol: 'kg' },
    { name: 'Liter', symbol: 'l' },
    { name: 'Kilometer', symbol: 'km' },
];
// ---------------------------------------------------------------------------
// Tags (KON-112)
// ---------------------------------------------------------------------------
const tagName = z.string().trim().min(2, 'Bezeichnung fehlt').max(40, 'Höchstens 40 Zeichen');
const tagColor = typeColorInput;
export const createProductTagInput = z.object({ name: tagName, color: tagColor.default('teal') });
export const updateProductTagInput = z
    .object({ name: tagName.optional(), color: tagColor.optional() })
    .strict()
    .refine((v) => Object.values(v).some((x) => x !== undefined), 'Keine Änderung angegeben');
export const reorderProductTagsInput = reorder;
//# sourceMappingURL=setup.js.map